// extracted by mini-css-extract-plugin
export default {"container":"salary_container__O6ojD","weekSelect":"salary_weekSelect__3zavM","pageName":"salary_pageName__pfxUF","title":"salary_title__E2PWR","count":"salary_count__mejDy"};